import React from 'react';
import ReactDOM from 'react-dom/client';
import { initPostHog } from './posthog';
import App from './App';
import './index.css';

initPostHog();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
